import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchResultTypeContext } from '../../context/SearchResultTypeContext'
import { NoResults } from '@cbgms/components/src/utils/NoResults'

export const NoSearchResults: React.FC = () => {
  const { isPortal } = useSearchResultTypeContext()
  const { t } = useTranslation()

  return (
    <NoResults>{t(isPortal ? 'global.main_search_no_results_placeholder_portal' : 'global.main_search_no_results_placeholder')}</NoResults>
  )
}
